import { createStore } from '@vfde-sails/core';
import './style.scss';
import app from '../app/container/App';

createStore({});
app();
